
<template>
  <AppSuccess />
</template>

<script setup>
import AppSuccess from '@/components/organisms/AppSuccess/AppSuccess.vue'
</script>